import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { NotFound } from './components/site/NotFound.js';

/**
 * The router.
 *
 * `defaultPreload: 'intent'` is the one setting worth commenting on: hovering a
 * link starts fetching the route it points at. On a marketing site that is
 * almost free — these pages carry little data — and it is the difference
 * between an internal link feeling instant and feeling like a page load, which
 * is most of what makes the internal linking the brief asks for something a
 * visitor will actually use.
 */
export function getRouter() {
  return createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultNotFoundComponent: NotFound,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
